'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    max-width: 100%;\n    height: auto;\n    vertical-align: bottom;\n    min-height: 36px;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    position: relative;\n    display: inline-block;\n    padding: 4px 11px;\n    width: 100%;\n    font-size: 14px;\n    line-height: 1.5;\n    color: rgba(0,0,0,.65);\n    background-color: #fff;\n    background-image: none;\n    border: 1px solid #d9d9d9;\n    border-radius: 4px;\n    box-sizing: border-box;\n    transition: all .3s,height 0s;\n    &:hover,&:focus {\n        border-color: #007eff;\n    }\n    &:focus{\n        outline: 0;\n        box-shadow: 0 0 0 2px rgba(24,144,255,.2);\n    }\n    &[disabled] {\n        background-color: #f5f5f5;\n        opacity: 1;\n        cursor: not-allowed;\n        color: rgba(0,0,0,.25);\n        &:hover {\n            border-color: #d9d9d9;\n        }\n    }\n'], ['\n    max-width: 100%;\n    height: auto;\n    vertical-align: bottom;\n    min-height: 36px;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    position: relative;\n    display: inline-block;\n    padding: 4px 11px;\n    width: 100%;\n    font-size: 14px;\n    line-height: 1.5;\n    color: rgba(0,0,0,.65);\n    background-color: #fff;\n    background-image: none;\n    border: 1px solid #d9d9d9;\n    border-radius: 4px;\n    box-sizing: border-box;\n    transition: all .3s,height 0s;\n    &:hover,&:focus {\n        border-color: #007eff;\n    }\n    &:focus{\n        outline: 0;\n        box-shadow: 0 0 0 2px rgba(24,144,255,.2);\n    }\n    &[disabled] {\n        background-color: #f5f5f5;\n        opacity: 1;\n        cursor: not-allowed;\n        color: rgba(0,0,0,.25);\n        &:hover {\n            border-color: #d9d9d9;\n        }\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _withFieldWrapper = require('../hocs/withFieldWrapper');

var _withFieldWrapper2 = _interopRequireDefault(_withFieldWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Textarea = _styledComponents2.default.textarea(_templateObject);

var TextareaComponent = function (_Component) {
    _inherits(TextareaComponent, _Component);

    function TextareaComponent() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TextareaComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextareaComponent.__proto__ || Object.getPrototypeOf(TextareaComponent)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
            return _this.props.onChange(e.target.value);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TextareaComponent, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                value = _props.value,
                disabled = _props.disabled;


            return _react2.default.createElement(Textarea, {
                value: value,
                onChange: this.onChange,
                disabled: disabled,
                rows: 4,
                autosize: false });
        }
    }]);

    return TextareaComponent;
}(_react.Component);

TextareaComponent.propTypes = {
    value: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    disabled: _propTypes2.default.bool
};
exports.default = (0, _withFieldWrapper2.default)(TextareaComponent);